/* eslint-disable @typescript-eslint/no-explicit-any */
import { IOssixProvider } from 'interfaces/otherInterface/dynamicInput';
import {
  ActionType,
  DestType,
  GatewayType,
  TargetType,
  TransferSourceType,
} from 'types/generalType';
import gatewayTransferConfirmation from 'utils/payloads/gatewayTransferConfirmation';

interface BankTransferParm {
  transferConfirmation?: any;
  onSaveBeneficiary?: any;
  provider?: IOssixProvider;
  inputFormValue?: any;
  country?: string;
  accountNumber?: string;
  amount?: string;
  accountNumberName?: string;
  saveContact?: boolean;
  pin?: string;
  sendFundsToGateway?: any;
  userPhoneNumber?: string;
  sourceWallet?: string;
  destinationCountry?: string;
  targetAccountNumber?: string;
  targetUrl?: string;
  targetPhoneNumber?: string;
  formValues?: any;
  otherKeys?: any;
  OTP?: string;
  SelfieURL?: string;
  setVerificationData?: any;
  setShowVerificationModal?: any;
  nextStep?: any;
  Toast?: any;
  transferConfirmationMessage?: string;
  clearTransferConfirmation?: () => void;
  api?: any;
  description?: string;
}

export const BankTransferConfirmation = ({
  provider,
  inputFormValue,
  country,
  accountNumber,
  amount,
  accountNumberName,
  otherKeys,
  targetAccountNumber,
  targetPhoneNumber,
  userPhoneNumber,
  description,
}: BankTransferParm) => {
  const {
    inputField,
    phoneNumber,
    firstName,
    lastName,
    ...restFormValues
  } = inputFormValue;

  const payload = gatewayTransferConfirmation({
    ActionType: provider?.ActionType,
    TargetType: provider?.Category,
    Category: provider?.Category,
    GatewayOperationType: GatewayType.BANK_TRANSFER,
    AccountNumber: accountNumber,
    SourceWallet: accountNumber,
    BrandUnikID: provider?.BrandUnikID,
    ShortName: provider?.ShortName,
    Amount: amount?.toString() || '',
    DestType: DestType.SELF,
    SourceType: TransferSourceType.BANK,
    TargetCountryCode: country || provider?.CountryCode,
    TargetAccountNumber:
      targetAccountNumber ||
      restFormValues?.serviceNumber ||
      restFormValues?.accountNumber ||
      accountNumber ||
      phoneNumber ||
      userPhoneNumber,
    PartnerRequest: {
      reason: description,
      accountNumber: targetAccountNumber || accountNumber,
      merchant: provider?.ShortName || provider?.OperatorName,
      phoneNumber:
        targetPhoneNumber || phoneNumber || userPhoneNumber,
      ...restFormValues,
    },
    otherKeys: { ...otherKeys },
  });

  return {
    transferConfirmation: payload,
    saveBenef: {
      CountryCode: country,
      ActionType: provider?.ActionType || '',
      ShortName: provider?.ShortName,
      Category: provider?.Category,
      CustomerID: '',
      AccountNumber: inputFormValue?.serviceNumber || '',
      FirstName: firstName || accountNumberName || '',
      LastName: lastName || '',
      PhoneNumber: phoneNumber,
      ...restFormValues,
    },
  };
};

export const BankTransfer = ({
  pin,
  inputFormValue,
  sendFundsToGateway,
  provider,
  accountNumber,
  amount,
  userPhoneNumber,
  sourceWallet,
  destinationCountry,
  targetAccountNumber,
  targetPhoneNumber,
  targetUrl,
  formValues,
  otherKeys,
  OTP,
  SelfieURL,
}: BankTransferParm) => {
  const {
    inputField,
    phoneNumber,
    firstName,
    lastName,
    description,
    ...restFormValues
  } = inputFormValue;

  const {
    Amount,
    type,
    verifyAccount,
    verifyURL,
    amountType,
    ...restValues
  } = formValues;

  const payload = {
    PIN: pin,
    DepositorName: '',
    TargetType: TargetType.Bank,
    GatewayOperationType: GatewayType.BANK_TRANSFER,
    Category: provider?.Category,
    ActionType: ActionType.Transfer,
    BrandUnikID: provider?.BrandUnikID,
    ShortName: provider?.ShortName,
    SourceWallet: sourceWallet || '',
    AccountNumber: accountNumber,
    Amount: amount || '',
    TargetCountryCode: destinationCountry || '',
    FirstName: firstName || '',
    LastName: lastName || '',
    OperatorID: provider?.OperatorID,
    OperatorName: provider?.OperatorName,
    ServiceRef: provider?.ServiceRef,
    TransferURL: targetUrl || '',
    SwiftCode: '',
    IBAN: '',
    DestType: DestType.OTHER,
    SourceType: TransferSourceType.BANK,
    SendVoucher: provider?.AcceptVoucher,
    ContactPID: '',
    OTP: OTP || '',
    SelfieURL: SelfieURL || '',
    Description: description || '',
    TargetAccountNumber:
      targetAccountNumber ||
      restFormValues?.serviceNumber ||
      restFormValues?.accountNumber ||
      accountNumber ||
      phoneNumber ||
      userPhoneNumber,
    PartnerRequest: {
      reason: description || '',
      accountNumber: targetAccountNumber || accountNumber,
      merchant: provider?.ShortName || provider?.OperatorName,
      phoneNumber:
        targetPhoneNumber || phoneNumber || userPhoneNumber,
      ...restValues,
      ...restFormValues,
    },
    ...otherKeys,
  };

  sendFundsToGateway(payload);
};
